import { render, staticRenderFns } from "./tagsFilter.vue?vue&type=template&id=c1467724"
import script from "./tagsFilter.vue?vue&type=script&lang=js"
export * from "./tagsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports